export class Dictionary {
  public static SERVER_ERROR = 'Some server error occurs';
  public static LOGIN_SUCCESS = 'Login successfully';
  public static LOGOUT_SUCCESS = 'Logout successfully';
}
